import { Component, Element, h, Host, Prop } from '@stencil/core';

import { state as headerState } from './pn-marketweb-siteheader-store';
import { LoginDialogLink } from './pn-marketweb-siteheader-types';
import { arrow_right, transfer } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-marketweb-siteheader-login-linklist',
  styleUrl: 'pn-marketweb-siteheader-login-linklist.scss',
})
export class PnMarketwebSiteheaderLoginLinklist {
  @Element() hostElement: HTMLElement;

  @Prop() heading: string = null;
  @Prop() links: LoginDialogLink[] = [];
  @Prop() idNamespace: string = '';
  @Prop() showUnifiedLogin: boolean = false;

  componentWillLoad() {}

  uniqueId(text: string) {
    return 'loginlink-' + text.replace(/[^A-Za-z0-9.\\\/]/gim, '') + '-' + this.idNamespace;
  }

  linkAppearanceAttributes(link) {
    let attributes = {};
    if (link.linkType) {
      switch (link.linkType) {
        case 'primary':
          attributes = {
            appearance: '',
            variant: '',
          };
          break;
        case 'secondary':
          attributes = {
            appearance: 'light',
            variant: 'outlined',
          };
          break;
        case 'regularlink':
        default:
          attributes = {
            appearance: 'light',
            variant: 'borderless',
            icon: arrow_right,
          };
          break;
      }
      return attributes;
    }
    if (!link.linkType) {
      attributes = {
        appearance: link.primaryLinkApperance ? 'dark' : 'light',
      };
    }
    return attributes;
  }

  renderListAsButtons(link) {
    return (
      <li>
        <pn-button
          href={link.href}
          id={this.uniqueId(link.linkText)}
          {...(link.openInNewWindow && { target: '_blank' })}
          {...this.linkAppearanceAttributes(link)}
          onClick={() => {
            if (link.isLogoutLink) {
              headerState.loginManager.clearUserData();
            }
          }}
        >
          {link.linkText}
        </pn-button>
      </li>
    );
  }

  renderListAsLinks(link) {
    return (
      <li>
        <a
          href={link.href}
          id={this.uniqueId(link.linkText)}
          {...(link.openInNewWindow && { target: '_blank' })}
          onClick={() => {
            if (link.isLogoutLink) {
              headerState.loginManager.clearUserData();
            }
          }}
        >
          {link.linkText}
          {link.isLogoutLink ? <pn-icon icon={transfer}></pn-icon> : <pn-icon icon={arrow_right}></pn-icon>}
        </a>
      </li>
    );
  }

  render() {
    if (!this.links || this.links.length === 0) {
      return;
    }
    return (
      <Host>
        {this.heading ? <p class="pn-marketweb-siteheader-login-linklist-heading">{this.heading}</p> : null}
        <ul>
          {this.links.map(link => {
            {
              return this.showUnifiedLogin ? this.renderListAsLinks(link) : this.renderListAsButtons(link);
            }
          })}
        </ul>
      </Host>
    );
  }
}
